import React, { Component } from 'react';
import Form from '../common/form';
import Joi from 'joi';
import { Container } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config.json';
import AuthService from '../../services/authService';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import IconBreadcrumbs from '../custom-breadcrumb';
import { Formik } from 'formik';
import Box from '@mui/material/Box';
import { Button, TextField, Typography, Paper } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';

class RegisterPage extends Form {
  apiEndPoint = config.apiEndPoint + 'users/register';

  schema = Yup.object().shape({
    username: Yup.string()
      .required('User is a required field')
      .min(4, 'Minimum is 4 characters')
      .max(15, 'Maximum is 15 digits'),
    password: Yup.string()
      .required('Password is a required field')
      .min(4, 'Minimum is 4 characters')
      .max(15, 'Maximum is 15 digits'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords must match'),
    email: Yup.string()
      .required('Email is a required field')
      .email('Please enter a valid Email'),
  });

  recaptchaRef = React.createRef();

  async doSubmit(values, captchaResponse) {
    return axios
      .post(this.apiEndPoint, { ...values, captchaResponse: captchaResponse })
      .then((result) => result.data)
      .then(() => {
        toast.success('Successfully Registered.');
        setTimeout(() => {
          window.location = '/downloads';
        }, 3000);
      })
      .catch((ex) => ex?.response?.data)
      .then((ex) => {
        if (ex) {
          toast.error(ex);
          this.recaptchaRef.current.reset();
        }
      });
  }

  render() {
    return (
      <>
        <IconBreadcrumbs name={'Register'} />
        <Container>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="80vh"
          >
            <Paper
              elevation={10}
              sx={{
                p: 4,
                backgroundColor: '#2c2c2c',
                borderRadius: '12px',
                maxWidth: 500,
                width: '100%',
              }}
            >
              <Typography
                variant="h5"
                align="center"
                gutterBottom
                sx={{ color: '#ffffff', fontWeight: 'bold' }}
              >
                Start Playing Now
              </Typography>

              <Formik
                validationSchema={this.schema}
                initialValues={{
                  username: '',
                  password: '',
                  confirmPassword: '',
                  email: '',
                }}
                onSubmit={(values) => {
                  this.doSubmit(values, this.recaptchaRef.current.getValue());
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <form noValidate onSubmit={handleSubmit}>
                    <Box mb={2}>
                      <TextField
                        fullWidth
                        autoComplete="username"
                        type="text"
                        label="Username"
                        name="username"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.username}
                        placeholder="Enter your username"
                        variant="outlined"
                        InputLabelProps={{ style: { color: '#aaa' } }}
                        InputProps={{
                          style: {
                            color: '#fff',
                            borderColor: '#555',
                          },
                        }}
                      />
                      {errors.username && touched.username && (
                        <Typography color="error" variant="body2" mt={1}>
                          {errors.username}
                        </Typography>
                      )}
                    </Box>

                    <Box mb={2}>
                      <TextField
                        fullWidth
                        type="password"
                        name="password"
                        label="Password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password}
                        placeholder="Enter your password"
                        variant="outlined"
                        InputLabelProps={{ style: { color: '#aaa' } }}
                        InputProps={{
                          style: {
                            color: '#fff',
                            borderColor: '#555',
                          },
                        }}
                      />
                      {errors.password && touched.password && (
                        <Typography color="error" variant="body2" mt={1}>
                          {errors.password}
                        </Typography>
                      )}
                    </Box>

                    <Box mb={2}>
                      <TextField
                        fullWidth
                        type="password"
                        name="confirmPassword"
                        label="Confirm Password"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.confirmPassword}
                        placeholder="Re-enter your password"
                        variant="outlined"
                        InputLabelProps={{ style: { color: '#aaa' } }}
                        InputProps={{
                          style: {
                            color: '#fff',
                            borderColor: '#555',
                          },
                        }}
                      />
                      {errors.confirmPassword && touched.confirmPassword && (
                        <Typography color="error" variant="body2" mt={1}>
                          {errors.confirmPassword}
                        </Typography>
                      )}
                    </Box>

                    <Box mb={2}>
                      <TextField
                        fullWidth
                        type="email"
                        name="email"
                        label="Email"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                        placeholder="Enter your email"
                        variant="outlined"
                        InputLabelProps={{ style: { color: '#aaa' } }}
                        InputProps={{
                          style: {
                            color: '#fff',
                            borderColor: '#555',
                          },
                        }}
                      />
                      {errors.email && touched.email && (
                        <Typography color="error" variant="body2" mt={1}>
                          {errors.email}
                        </Typography>
                      )}
                    </Box>

                    <Box mb={3} textAlign="center">
                      <ReCAPTCHA
                        ref={this.recaptchaRef}
                        sitekey={config.RECAPTCHA_SITE_KEY}
                      />
                    </Box>

                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      sx={{
                        backgroundColor: '#4caf50',
                        color: '#fff',
                        fontWeight: 'bold',
                        '&:hover': {
                          backgroundColor: '#45a049',
                        },
                      }}
                    >
                      Register Your Account
                    </Button>
                  </form>
                )}
              </Formik>
            </Paper>
          </Box>
        </Container>
      </>
    );
  }
}

export default RegisterPage;
